import { PntStationStatusItemDtoV2 } from '@mi-front/core';
import { Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { scheduleStatusMentionsContentMessage } from './schedule-status-mentions-messages';

interface ScheduleStatusMentionsDetailContentProps {
  item: PntStationStatusItemDtoV2;
}

/**
 * Mention script (`dateSchedule.original`) shown as pre-wrapped text.
 */
export function ScheduleStatusMentionsDetailContent({
  item,
}: ScheduleStatusMentionsDetailContentProps) {
  const original = item.dateSchedule?.original?.trim();

  if (!original) {
    return null;
  }

  return (
    <Box>
      <Typography variant="caption" color="text.secondary" sx={{ mb: 1 }}>
        <FormattedMessage {...scheduleStatusMentionsContentMessage} />
      </Typography>
      <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
        {original}
      </Typography>
    </Box>
  );
}
